<!--suppress CheckTagEmptyBody -->
<template>
  <div class="modal" ref="modal" :class="{'is-active': showModal}">
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-content" :class="{'text-center': textCentered}">
      <slot></slot>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: "Modal",
    computed: mapState(['showModal']),
    props: {
      textCentered: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      closeModal() {
        this.$store.dispatch('closeModal');
      },
    },
  }
</script>

<style scoped lang="scss">
  .modal-content {
    background-color: white;
    padding: 3rem;

    footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-top: 1rem;

      button {
        &:last-child {
          margin-left: 1rem;
        }
      }
    }
  }

  .text-center {
    text-align: center;
  }
</style>
